import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Autocomplete, Box, Typography } from "@mui/material";
import { useMemo } from "react";
import AnchorPopper from "../../../../../../components/forms/AnchorPopper";
import {
  getTextFieldInputProps,
  StyledTextField,
  textFieldLabelProps,
} from "../../../../../../components/forms/styles/formFieldStyles";

const JiraProjectName = ({
  options,
  showOptions,
  selectedOption,
  setSelectedOption,
}) => {
  const projectNameLabel = useMemo(() => {
    const labelText = selectedOption ? "Project name" : "Select project name";

    return <Typography variant="caption">{labelText}</Typography>;
  }, [selectedOption]);

  return (
    <Autocomplete
      options={options || []}
      disabled={!showOptions}
      getOptionLabel={(option) => option.name}
      value={selectedOption}
      onChange={(_, newValue) => setSelectedOption(newValue)}
      popupIcon={<ExpandMoreIcon />}
      PopperComponent={AnchorPopper}
      renderOption={(props, option) => (
        <Box component="li" {...props}>
          <Typography variant="caption">{option.name}</Typography>
        </Box>
      )}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          margin="dense"
          label={projectNameLabel}
          fullWidth
          required
          InputProps={getTextFieldInputProps(params.InputProps)}
          InputLabelProps={textFieldLabelProps(params.InputLabelProps)}
        />
      )}
    />
  );
};
export default JiraProjectName;
